'use client';

import {LoadingBlur} from '@delorand/ui/src/loader';

function GeneralLoading() {
  return <LoadingBlur />;
}

export default GeneralLoading;
